
import mixins from 'vue-typed-mixins';
import { mapState, mapGetters, mapActions } from 'vuex';

import tableViewMixin from '@/components/mixins/table-view';
import NotificationBanner from '@/components/blocks/notification-banner.vue';
import TableListSkeleton from '@/components/skeletons/table-list.vue';
import Dropdown, { DropdownItems } from '@/components/controls/dropdown.vue';

import { formatNumber } from '@/i18n';
import Distributor, { DistributorStatus } from '@/store/modules/distributors/distributor';
import { DistributorsActions } from '@/store/modules/distributors/types';

export default mixins(tableViewMixin).extend({
  name: 'DistributorsView',
  components: {
    NotificationBanner,
    TableListSkeleton,
    Dropdown,
  },
  props: {
    paginated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sort: 'name',
      direction: 'DESC',
    };
  },
  created() {
    if (!this.sort) {
      this.sort = 'name';
    }
    if (!this.direction) {
      this.direction = 'DESC';
    }
  },
  computed: {
    ...mapState('distributors', {
      distributors: 'list',
    }),
    ...mapGetters('distributors', {
      isLoading: 'listIsLoading',
      isLoaded: 'listIsLoaded',
      isEmpty: 'listIsEmpty',
    }),
    sortedDistributors(): Distributor[] {
      const list = [...this.distributors];
      const dir = this.direction === 'ASC' ? 1 : -1;
      const key = this.sort;
      list.sort((a, b) => {
        let av: string | number;
        let bv: string | number;
        if (key === 'status') {
          av = a.status;
          bv = b.status;
        } else {
          av = a.name.toLowerCase();
          bv = b.name.toLowerCase();
        }
        if (av < bv) {
          return -1 * dir;
        }
        if (av > bv) {
          return 1 * dir;
        }
        return 0;
      });
      return list;
    },
  },
  methods: {
    formatNumber,
    ...mapActions('distributors', {
      removeAction: DistributorsActions.DELETE,
      restoreAction: DistributorsActions.RESTORE,
    }),
    applySort(field: string) {
      if (this.isCurrentSort(field)) {
        this.direction = this.toggleDirection(this.direction);
      } else {
        this.sort = field;
        this.direction = 'DESC';
      }
    },
    isActive(distributor: Distributor) {
      return distributor.status === DistributorStatus.Active;
    },
    dropdownItems(distributor: Distributor) {
      const items: DropdownItems = {
        edit: {
          label: this.$t('Edit'),
          icon: 'pencil',
        },
      };

      if (distributor.status === DistributorStatus.Inactive) {
        items.restore = {
          label: this.$t('Restore'),
          icon: 'restore',
        };
      } else {
        items.remove = {
          label: this.$t('Delete'),
          hasTopBorder: true,
          icon: 'trash',
        };
      }

      return items;
    },
    handleClick(distributor: Distributor, action: string) {
      if (action === 'edit') {
        this.$router.push({
          name: 'edit-distributor',
          params: { id: String(distributor.id) },
        });
      }

      if (action === 'restore') {
        const answer = window.confirm(this.$t('Do you really want to restore this distributor?'));

        if (answer) {
          this.restoreAction({ id: distributor.id });
        }
      }

      if (action === 'remove') {
        const answer = window.confirm(this.$t('Do you really want to delete this distributor?'));

        if (answer) {
          this.removeAction({ id: distributor.id });
        }
      }
    },
  },
});
